import { Pipe, PipeTransform } from '@angular/core'
import { EstimateBalanceWorkflowStatus } from '@mmx/shared'

const KEY_BY_STATUS: Record<EstimateBalanceWorkflowStatus, string> = {
  [EstimateBalanceWorkflowStatus.DRAFT]: 'balance.workflow-status.draft',
  [EstimateBalanceWorkflowStatus.CONFIRMED]: 'balance.workflow-status.confirmed',
  [EstimateBalanceWorkflowStatus.NA]: 'balance.workflow-status.na',
  [EstimateBalanceWorkflowStatus.NOT_READY]: 'balance.workflow-status.not-ready',
  [EstimateBalanceWorkflowStatus.NOT_STARTED]: 'balance.workflow-status.not-started',
}

@Pipe({
  name: 'balanceWorkflowStatus',
  standalone: true,
})
export class BalanceWorkflowStatusPipe implements PipeTransform {
  transform(value: EstimateBalanceWorkflowStatus | null | undefined): string {
    if (value == null) {
      return 'balance.workflow-status.unknown'
    }
    return KEY_BY_STATUS[value] ?? 'balance.workflow-status.unknown'
  }
}
